module.exports = __webpack_public_path__ + "img/marker-opening-group.55c68df2.svg";